<div class="subscription-wrap" [ngClass]="getWrapCssClasses()">
  <div class="header-row">

    <div class="left pointer" (click)="toggleShowDetails()">
      <span 
        class="subscription-icon"
        [ngClass]="item.icon">
      </span>
    </div>

    <div class="center pointer" (click)="toggleShowDetails()">
      <h4 class="name">{{ item.name }}</h4>
      <p class="code">{{ code }}</p>
      <p class="card-type">
        <span class="card-pill" [ngClass]="item.cardType">
          <span [ngClass]="getCardIcon(item)"></span>
          {{item.cardLabel}}
        </span>
      </p>
    </div>

    <div class="right pointer" (click)="toggleShowDetails()">
      <p class="price">{{ item.cost }} $</p>
      <p class="taxes" *ngIf="item.taxable">+ taxes</p>
      <p class="dates">
        {{ item.startDate | shortDate }} - <br>{{ formatDateUTC(item.endDate) }}
      </p>
    </div>

    <div class="checkbox" *ngIf="selectable" [formGroup]="form">
      <app-form-checkbox
        formControlName="selected"
        [disabled]="disableSelect"
        [validation]="false"
        [showMessages]="false"
        (change)="handleSelectToggle($event)">
      </app-form-checkbox>
    </div>

    <div *ngIf="!selectable && showContextMenu">
      <button mat-icon-button 
        [matMenuTriggerFor]="menu" 
        aria-label="Details">
        <span class="icon-more-vertical"></span>
      </button>
      <mat-menu #menu="matMenu" class="admin-user-sub-menu">
        <button mat-menu-item class="edit"
          (click)="openManagementDialog(item)">
          <mat-icon><span class="icon-edit"></span></mat-icon>
          <span>{{ 'pages.user-subscriptions.admin-menu.edit' | translate }}</span>
        </button>
        <button mat-menu-item class="delete"
          (click)="openDeleteDialog(item)">
          <mat-icon><span class="icon-trash-bin"></span></mat-icon>
          <span>{{ 'pages.user-subscriptions.admin-menu.delete' | translate }}</span>
        </button>
        <button mat-menu-item class="renew" *ngIf="isRenewalAllowed"
          (click)="onRenewClick()">
          <mat-icon><span class="icon-refresh"></span></mat-icon>
          <span>{{ 'pages.user-subscriptions.admin-menu.renew' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="errors-warnings-row" *ngIf="errors.length || warnings.length">
    <div class="errors" *ngIf="!!errors.length">
      <div class="error" *ngFor="let err of errors">
        <span class="icon-close"></span>
        {{ err.message }}
      </div>
    </div>
    <div class="warnings" *ngIf="!!warnings.length">
      <div class="warning" *ngFor="let warn of warnings">
        <span class="icon-warning"></span>
        {{ warn.message }}
      </div>
    </div>
  </div>

  <div class="details-row" [@toggleDetails]="showDetails">
    <h4>Description</h4>
    <p>{{ item.description }}</p>
  </div>
</div>